import React from 'react';
import { store } from '../../store'
import { insuranceTakersTypes } from './actions'
import { customerTypes } from '../customers/actions'
import { nationalRegistryTypes } from '../national-registry/actions'
const kennitala = require('kennitala')

const defaultInsuranceTaker = {
    phonenumber: '',
    email: '',
    cellularPhone: '',
    idType: '',
    idNumber: '',
    issuer: '',
    country: '',
    issueDate: null,
    validUntil: null,
    cityOfBirth: '',
    images: [],
    taxUSA: false,
    citizenUSA: false,
    connectionUSA: false,
    tinOrSsn: '',
    tinOrSsnSubmitLater: false,
    multipleCitizenships: false,
    citizenships: '',
    contactInfoConfirm: false,
    name: '',
    occupation: '',
    useExistingPhotoId: null,
    submitIdLater: null,
    confirm: false,
    taxInfoConfirm: false,
    // fields specific for FOR/FORE, 
    // registering the insured as apposed to the insuranceTaker
    // in these cases the insured is a child. Only relevant
    // for USA connetion
    // a better name would be insured*, but we want to map
    // to the AX model where it is *insured
    citizenUSAInsured: false,
    connectionToUSAInsured: false,
    tinOrSsnInsured: '',
    tinOrSsnInsuredSubmitLater: false,
    politicalConnPolicyHolder: false,    
    politicalConnInsured: false,
}

const _initialState = {
    isFetching: false,
    insuranceTakers: {},
    nationalRegistry: {}
}


export function insuranceTakers(state=_initialState, action) {
    switch(action.type) {
    
        case insuranceTakersTypes.SET_KEY:
            state = {...state}
            let insuranceTaker = state.insuranceTakers[action.insuranceTakerId]

            if (insuranceTaker) {
                if (action.key !== undefined) {
                    insuranceTaker[action.key] = action.value
                }

            } else {

                insuranceTaker = Object.assign({}, defaultInsuranceTaker)
                insuranceTaker.insuranceTakerId = action.insuranceTakerId

                if (action.key !== undefined) {
                    insuranceTaker[action.key] = action.value
                }

                state.insuranceTakers[action.insuranceTakerId] = insuranceTaker
            }

            return state

        case insuranceTakersTypes.ADD_INSURANCE_TAKER:
            state = {...state}

            let ins = Object.assign({}, defaultInsuranceTaker)
            ins.name = action.insuranceTaker.Name
            ins.customerId = action.insuranceTaker.OrgId
            
            state.insuranceTakers[ins.customerId] = ins

            return state

        case customerTypes.RECEIVE:
            state = {...state}

            if (kennitala.info(action.query).age > 17) {
                let p = null;
                let cu = action.data["Customer"];
                

                // Is action.query ever defined? Not in step0
                let _insuranceTaker = state.insuranceTakers[action.query]

                if (_insuranceTaker) {
                    _insuranceTaker["phonenumber"] = cu.Phone
                    _insuranceTaker["cellularPhone"] = cu.CellularPhone
                    _insuranceTaker["email"] = cu.Email
                    _insuranceTaker["name"] = cu.Name
                } else {
                    _insuranceTaker = Object.assign({}, defaultInsuranceTaker)
                    _insuranceTaker.customerId = cu.AccountNum
                    _insuranceTaker["phonenumber"] = cu.Phone
                    _insuranceTaker["cellularPhone"] = cu.CellularPhone
                    _insuranceTaker["email"] = cu.Email
                    _insuranceTaker["name"] = cu.Name

                }

                state.insuranceTakers[cu.AccountNum] = _insuranceTaker
            }

            
            return state

        case nationalRegistryTypes.RECEIVE:
            state = {...state}

            let _data = []

            if (action.data.length > 0) {
                let person = action.data[0].NationalRegistry
                if (kennitala.info(person.OrgId).age < 18) {
                    let family = []
                    if (person.FamilyList) {
                        family = person.FamilyList.Family
                    }
                    family = family.map(f => {
                        let ktinfo = kennitala.info(f.OrgId)
                        if (ktinfo.age > 17) {
                            let parentInsuranceTaker = state.insuranceTakers[f.OrgId]
                            if (!parentInsuranceTaker) {
                                parentInsuranceTaker = Object.assign({}, defaultInsuranceTaker)
                                parentInsuranceTaker.name = f.Name
                                parentInsuranceTaker.customerId = f.OrgId
                                parentInsuranceTaker.connectionUSA = f.BirthplaceCountryId == 'US'
                                parentInsuranceTaker.citizenUSA = f.BirthplaceCountryId == 'US'
                                state.insuranceTakers[f.OrgId] = parentInsuranceTaker
                            }
                        }
                    })
                } else {
                    let theParentInsuranceTaker = state.insuranceTakers[person.OrgId]
                    if (!theParentInsuranceTaker) {
                        theParentInsuranceTaker = Object.assign({}, defaultInsuranceTaker)
                        theParentInsuranceTaker.name = person.Name
                        theParentInsuranceTaker.customerId = person.OrgId
                        theParentInsuranceTaker.connectionUSA = person.BirthplaceCountryId == 'US'
                        theParentInsuranceTaker.citizenUSA = person.BirthplaceCountryId == 'US'
                        state.insuranceTakers[person.OrgId] = theParentInsuranceTaker
                    }
                }

                state.nationalRegistry[action.data[0].NationalRegistry.OrgId] = action.data[0].NationalRegistry;

            }


            return state
        default:
            return state
    }
}